import type {
  LinearSeriesSettings,
  SeriesSettings,
  ValueAxisType,
} from "../../../../../../../../../api/types/svTypes.ts";

export function getValueAxisType(serie: SeriesSettings | undefined): ValueAxisType {
  const linearSerie = serie as LinearSeriesSettings;
  return linearSerie?.valueAxis || "Main";
}
